import { useState } from "react";
import { getAPI } from "../helpers/httpHelper";
import { cognitoUserToken } from "../helpers/userHelper";
import { API_ADMIN_USER, URL_SUPPORT } from "../helpers/variableHelper";
import { usePromiseEffect } from "../helpers/promiseEffect";
import "./UserPicker.css";
import { ITipo_Campo } from "../helpers/IFormHelper";
import IUserPickerValue from "../entities/helper/IUserPickerValue";
import ICurrentUser from "../entities/helper/ICurrentUser";

interface IUserPickerProps {
  disabled: boolean;
  defaultValue?: Array<IUserPickerValue> | IUserPickerValue | null;
  multi: boolean;
  callback: (id: string, value: Array<IUserPickerValue>, tipoCampo?: ITipo_Campo) => void;
  id: string;
  name: string;
  className?: string;
  options: Array<IUserPickerValue>;
  showAD?: boolean;
  currentUser?: ICurrentUser;
  isExternoInspector: boolean;
}
const UserPickerData = ({
  disabled,
  defaultValue,
  multi,
  callback,
  id,
  name,
  className,
  options,
  showAD,
  currentUser,
  isExternoInspector,
}: IUserPickerProps) => {
  const [suggestions, setSuggestions] = useState<IUserPickerValue[]>([]);
  const [optionsState, setOptionsState] = useState<IUserPickerValue[]>(options);
  const [values, setValues] = useState([] as any[]);
  const [textValue, setTextValue] = useState("");
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [isInsideMouseListbox, setIsInsideMouseListbox] = useState(false);
  const imgDefault = "https://p16-tiktok-va-h2.ibyteimg.com/img/musically-maliva-obj/1624828413449221~c5_720x720.jpeg";

  usePromiseEffect(async () => {
    let token = await userInfo;
    setToken(token);
    setOptionsState(options);
    if (defaultValue) {
      if (
        (defaultValue as Array<IUserPickerValue>).length === undefined &&
        (defaultValue as IUserPickerValue).mail &&
        (defaultValue as IUserPickerValue).name
      ) {
        if ((defaultValue as IUserPickerValue).name != "") {
          setValues([
            {
              name: (defaultValue as IUserPickerValue).name,
              mail: (defaultValue as IUserPickerValue).mail,
              image: "https://p16-tiktok-va-h2.ibyteimg.com/img/musically-maliva-obj/1624828413449221~c5_720x720.jpeg",
            },
          ]);
        }
      }

      if ((defaultValue as Array<IUserPickerValue>).length > 0) {
        let maps: any[] = (defaultValue as Array<IUserPickerValue>).map((r: any) => {
          return { name: r.name, mail: r.mail };
        });
        setValues([...maps]);
      }
    }
  }, [token, defaultValue, options]);

  const getSuggestions = async (value: any) => {
    let val = value.target.value;
    setTextValue(val);
    let usuarios: any = [];
    if (val.length > 3) {
      setShowSuggestions(true);
      if (!currentUser?.external) {
        if (showAD) {
          let result = await getAPI(`${URL_SUPPORT}${API_ADMIN_USER}/GetUsersAD/${val}`, { Authorization: `Bearer ${token}` });
          let users = result.result;
          usuarios = users.map((user: any) => {
            return {
              name: `${user.DISPLAY_NAME}`,
              description: `${user.DISPLAY_NAME} (${user.EMAIL})`,
              mail: user.EMAIL,
              image: imgDefault,
            };
          });
        }
        setSuggestions([...usuarios]);
      }
      setOptionsState([...options.filter((o) => o.name.toLowerCase().includes(val.toLowerCase()))]);
    } else {
      setShowSuggestions(false);
      setSuggestions(usuarios);
    }
    return usuarios;
  };

  const eliminarElemento = (index: number) => {
    values.splice(index, 1);
    setValues([...values]);
    callback(id, values, ITipo_Campo.user);
  };

  const seleccionadoElemento = (item: any) => {
    if (multi) {
      values.push({
        name: item.name,
        mail: item.mail,
        image: item.image,
      });
    } else {
      values[0] = {
        name: item.name,
        mail: item.mail,
        image: item.image,
      };
    }
    setTextValue("");
    setValues([...values]);
    setIsInsideMouseListbox(false);
    callback(id, values, ITipo_Campo.user);
  };

  return (
    <div>
      <button
        hidden={true}
        data-testid="btngetsuggestions"
        onClick={() => {
          getSuggestions({ target: { value: "eeee" } });
        }}></button>
      <button
        hidden={true}
        data-testid="btneliminar"
        onClick={() => {
          eliminarElemento(0);
        }}></button>
      <button
        hidden={true}
        data-testid="btnseleccionar"
        onClick={() => {
          seleccionadoElemento({ mail: "", name: "", description: "" } as IUserPickerValue);
        }}></button>
      <div className={`sc-AxirZ bJCmFu ${className}`}>
        {values.map((v, i) => {
          return (
            <div key={`$div:${v.mail}`} data-tag-index="0" className="sc-AxiKw eSbheu">
              <span key={`$span:${v.mail}`} title={v.mail}>
                <img className="rounded-circle" height={32} width={32} src={v.image || imgDefault} />
                {v.name}
              </span>
              <svg
                key={`$svg:${v.mail}`}
                className="MuiSvgIcon-root"
                focusable="false"
                onClick={() => {
                  disabled ? console.log() : eliminarElemento(i);
                }}
                viewBox="0 0 24 24"
                aria-hidden="true">
                <path
                  key={`$path:${v.mail}`}
                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
              </svg>
            </div>
          );
        })}
        <input
          type="text"
          disabled={disabled ? true : !multi && values.length > 0}
          aria-autocomplete="list"
          autoComplete="off"
          spellCheck={false}
          onChange={(e) => {
            getSuggestions(e);
          }}
          value={textValue}
          onFocus={(e) => {
            getSuggestions(e);
          }}
          onBlur={() => {
            if (!isInsideMouseListbox) {
              setShowSuggestions(false);
            }
          }}
        />
      </div>
      {(optionsState.length > 0 || suggestions.length > 0) && showSuggestions ? (
        <ul role="listbox" className="listbox" onMouseEnter={() => setIsInsideMouseListbox(true)} onMouseLeave={() => setIsInsideMouseListbox(false)}>
          {optionsState
            .concat(suggestions)
            .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
            .map((s, index) => {
              return (
                <li
                  key={`$li:${s.mail}`}
                  title={s.mail}
                  onClick={() => {
                    seleccionadoElemento(s);
                    setShowSuggestions(false);
                  }}>
                  {<img onChange={() => {}} className="rounded-circle" height={32} width={32} src={s.image || imgDefault} />}
                  {s.name}
                </li>
              );
            })}
        </ul>
      ) : (optionsState.length === 0 || suggestions.length === 0) && showSuggestions ? (
        <ul role="listbox" className="listbox">
          <li>No se encontraron resutados</li>
        </ul>
      ) : (
        ""
      )}
      <input type="hidden" name={`${id}_DISPLAY`} value={values[0]?.name} />
      <input type="hidden" name={id} value={values[0]?.mail} />
    </div>
  );
};

export default UserPickerData;
